import {useEffect, useState} from "react";
import {KTCard} from "../../../_metronic/helpers";
import axios from "axios";
import {toast} from "react-toastify";
import {UserApiTable} from "./table/UserApiTable";
import {UserApiHeader} from "./header/UserApiHeader";
import {useAuth} from "../auth";

const Index = () => {
    const { currentUser, haveAccess } = useAuth();
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const fetchApiUsage = async () => {
        try {
            setLoading(true);
            const {data} = await axios.get(`${process.env.REACT_APP_API_V3_URL}/partner?page=${page}&page_size=${pageSize}`);
            setData(data.data)
            setTotal(data.total);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Could not fetch API usage');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchApiUsage()
    }, [page, pageSize])

    return (
        <KTCard>
            {
            (haveAccess(currentUser,  'booking_list') && haveAccess(currentUser,  'partner_users_list')) ?
            <>
            <UserApiHeader/>
            <UserApiTable
                data={data}
                isLoading={isLoading}
                fetchApiUsage={fetchApiUsage}
                total={total}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
            />
            </>
            :
            <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
                You do not have permission to view
            </div>
            }
        </KTCard>
        
    );
};

export default Index;
